import dayjs from 'dayjs'
import { defineStore } from 'pinia'
import { computed, ref } from 'vue'

import { useIntervalArray } from '@/composables/useIntervalArray'
import { ARTICLE_FETCH_INTERVAL, ARTICLE_INTERVAL } from '@/constants/times'
import { httpService } from '@/service/http.service'
import type { JournalArticle } from '@/types'

export const useJournalStore = defineStore('journal', () => {
  const journalArticles = ref<JournalArticle[]>([])

  const currentIndex = ref(0)

  const { start: startSlider } = useIntervalArray(
    [ARTICLE_INTERVAL],
    nextArticle
  )

  function nextArticle() {
    if (journalArticles.value.length > 0)
      currentIndex.value =
        (currentIndex.value + 1) % journalArticles.value.length
  }

  const article = computed(() => journalArticles.value[currentIndex.value])

  async function fetchArticle() {
    try {
      const journalResponse =
        await httpService.infoboards.infoboardsPublicJournalArticlesList()
      const now = dayjs()
      journalArticles.value = journalResponse.map((article, index) => ({
        ...article,
        id: now.format() + index
      }))
    } catch {
      // console.log(err)
    }
  }

  const { start } = useIntervalArray([ARTICLE_FETCH_INTERVAL], fetchArticle)

  function bootstrapJournalStore() {
    start()
    startSlider()
  }

  return {
    article,
    bootstrapJournalStore
  }
})
